// AUTO-GENERATED SQL Builder (V40 Final) for EarlyRelease
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class EarlyReleaseSql {
  private ast = new SqlAst('EarlyRelease', 'earlyRelease');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public vendorId: SqlField;
  public amount: SqlField;
  public source: SqlField;
  public status: SqlField;
  public requestedDate: SqlField;
  public paidDate: SqlField;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public vendor: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('earlyRelease', 'guid', '', 'id', 'earlyRelease_guid');
    this.bookingId = new SqlField('earlyRelease', 'bookingId', 'booking', 'id', 'earlyRelease_booking');
    this.vendorId = new SqlField('earlyRelease', 'vendorId', 'vendor', 'id', 'earlyRelease_vendor');
    this.amount = new SqlField('earlyRelease', 'amount', '', 'id', 'earlyRelease_amount');
    this.source = new SqlField('earlyRelease', 'source', '', 'id', 'earlyRelease_source');
    this.status = new SqlField('earlyRelease', 'status', '', 'id', 'earlyRelease_status');
    this.requestedDate = new SqlField('earlyRelease', 'requestedDate', '', 'id', 'earlyRelease_requestedDate');
    this.paidDate = new SqlField('earlyRelease', 'paidDate', '', 'id', 'earlyRelease_paidDate');
    this.booking = createNavHybrid('earlyRelease', 'earlyRelease_booking', 'Booking');
    this.createdByUser = createNavHybrid('earlyRelease', 'earlyRelease_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('earlyRelease', 'earlyRelease_updatedByUser', 'User');
    this.vendor = createNavHybrid('earlyRelease', 'earlyRelease_vendor', 'Vendor');
    this.id = new SqlField('earlyRelease', 'id', '', 'id', 'earlyRelease_id');
    this.isDeleted = new SqlField('earlyRelease', 'isDeleted', '', 'id', 'earlyRelease_isDeleted');
    this.createdBy = new SqlField('earlyRelease', 'createdBy', '', 'id', 'earlyRelease_createdBy');
    this.createdDate = new SqlField('earlyRelease', 'createdDate', '', 'id', 'earlyRelease_createdDate');
    this.updatedBy = new SqlField('earlyRelease', 'updatedBy', '', 'id', 'earlyRelease_updatedBy');
    this.updatedDate = new SqlField('earlyRelease', 'updatedDate', '', 'id', 'earlyRelease_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:EarlyReleaseSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:EarlyReleaseSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:EarlyReleaseSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:EarlyReleaseSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:EarlyReleaseSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:EarlyReleaseSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:EarlyReleaseSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:EarlyReleaseSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:EarlyReleaseSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:EarlyReleaseSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
